<template>
  <div>
    <b-form-group :label="trans('button_text')">
      <b-form-input
        v-model="text"
        :placeholder="placeholder"
        :disabled="disabled"
      />
    </b-form-group>
    <b-form-group :label="trans('button_url')">
      <b-form-radio-group v-model="mode" :options="modeOptions">
      </b-form-radio-group>
    </b-form-group>
    <b-form-group>
      <b-form-input
        v-if="mode == 'url'"
        v-model="url"
        :placeholder="url_placeholder"
        :state="buttonState"
        :disabled="disabled"
        @input="onUrlChange"
      />
      <b-form-text v-if="mode == 'url' && buttonError" class="text-danger">
        {{ buttonError }}
      </b-form-text>
      <div v-if="mode == 'form'">
        <form-dropdown
          :organization="organization"
          v-model="recipient_form_id"
          :initial_page_url="initialFormUrl"
          :placeholder="trans('choose_a_form')"
          nullable
          mode="forms"
          @list="onSelectForm"
          :disabled="disabled"
          style="margin-bottom: 10px;"
        ></form-dropdown>
        <b-form-group :label="trans('preset_form_with')" v-if="!showMore">
          <Treeselect
            v-model="form_placeholders"
            :options="placeholderOptions"
            multiple
            search-nested
            disable-branch-nodes
            @select="onPlaceHolderSelect"
            :placeholder="trans('fields')"
            :disabled="disabled || !recipient_form_id"
          />
        </b-form-group>
      </div>
      
      <div v-if="mode == 'document'">
        <document-dropdown
          :organization="organization"
          v-model="document_id"
          :initial_short_url="button_url"
          nullable
          @document="onSelectDocument"
          :disabled="disabled"
        ></document-dropdown>
        <div class="text-center">
          <em>{{ trans('or') }}</em>
        </div>
        <b-form-group :label="trans('upload')">
          <b-form-file
            v-model="upload_file"
            :placeholder="trans(organization.allow_non_pdf_document_upload ? 'upload_document' : 'upload_pdf')"
            :drop-placeholder="trans('drop_file_here')"
            :accept="organization.allow_non_pdf_document_upload ? '.pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx' : 'application/pdf'"
            :disabled="busy"
            @input="onDocumentFileChange(null)"
          />
        </b-form-group>
        <p v-if="busy">
          <i class="fa fa-fw fa-circle-notch fa-spin"></i>
          {{ trans('please_wait') }}
        </p>
        <p v-if="error" class="text-danger">
          {{ error }}
        </p>
      </div>

      <div v-if="mode == 'i_calendar' && showICalendar">
        <p><small>{{ trans('i_calendar_desc') }}</small></p>
      </div>
      <div v-if="mode == 'pay_invoice' && showPayInvoice">
        <p><small>{{ trans('pay_invoice_link_desc') }}</small></p>
      </div>

      <page-dropdown
        v-if="mode == 'page'"
        :organization="organization"
        v-model="page_id"
        :initial_short_url="button_url"
        nullable
        @page="onSelectPage"
        :disabled="disabled"
      ></page-dropdown>
      <b-input-group v-if="mode == 'email'">
        <b-form-input type="email" v-model="url" :disabled="disabled" />
        <template #prepend>
          <b-dropdown variant="outline-secondary" :disabled="disabled">
            <b-dropdown-item v-for="email in emails" :key="email" @click="url=email">
              {{ email }}
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-input-group>
      <b-form-text v-if="mode == 'email' && !!emailError" class="text-danger">
        {{ emailError }}
      </b-form-text>
    </b-form-group>
      <b-input-group v-if="mode == 'tel'">
        <b-form-input type="tel" v-model="url" :disabled="disabled" />
        <template #prepend>
          <b-dropdown variant="outline-secondary" :disabled="disabled">
            <b-dropdown-item v-for="phone in phones" :key="phone" @click="url=phone">
              {{ phone }}
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-input-group>
      <b-form-text v-if="mode == 'tel' && !!phoneError" class="text-danger">
        {{ phoneError }}
      </b-form-text>
    </b-form-group>
    <div v-if="showMore">
      <b-form-group :label="trans('anchor_target')">
        <b-form-select
          v-model="target"
          :options="targetOptions"
          :disabled="disabled"
        ></b-form-select>
      </b-form-group>
    </div>
  </div>
</template>
<script>
  import FormDropdown from './../list/ListDropdown'
  import DocumentDropdown from './../media/DocumentDropdown'
  import PageDropdown from './../page/PageDropdown'
  import Treeselect from '@riophae/vue-treeselect'

  export default {
    props: {
      organization: Object,
      button_text: String,
      button_url: String,
      button_color: String,
      button_target: String,
      button_protocol: String,
      disabled: {
        type: Boolean,
        default: false,
      },
      placeholder: {
        type: String,
        default: trans('button_text'),
      },
      url_placeholder: {
        type: String,
        default: trans('https://example.com'),
      },
      showMore: {
        type: Boolean,
        default: false,
      },
      showPage: {
        type: Boolean,
        default: true,
      },
      showICalendar: {
        type: Boolean,
        default: false,
      },
      showPayInvoice: {
        type: Boolean,
        default: false,
      },
      isPaymentForm: {
        type: Boolean,
        default: true
      }
    },
    components: {
      FormDropdown,
      DocumentDropdown,
      PageDropdown,
      Treeselect
    },
    data() {
      let mode = 'url'
      let type = _.linkType(this.button_url, undefined, this.organization.id)
      if (type == 'form') mode = 'form'
      else if (type == 'document') mode = 'document'
      else if (type == 'page') mode = 'page'
      else if (type == 'email') mode = 'email'
      else if (type == 'tel') mode = 'tel'
      else if (type == 'i_calendar') mode = 'i_calendar'
      else if (type == 'pay_invoice') mode = 'pay_invoice'
      
      return {
        trans: trans,
        busy: false,
        error: null,
        text: this.button_text,
        url: this.button_url,
        color: this.button_color,
        target: this.button_target,
        protocol: this.button_protocol,
        mode: mode,
        modeOptions: _.compact([
          {text: 'URL', value: 'url'},
          {text: trans('form'), value: 'form'},
          {text: trans('document'), value: 'document'},
          this.showPage ? {text: trans('page'), value: 'page'} : null,
          {text: trans('email'), value: 'email'},
          {text: trans('telephone'), value: 'tel'},
          this.showICalendar ? {text: trans('i_calendar'), value: 'i_calendar'} : null,
          this.showPayInvoice ? {text: trans('pay_invoice'), value: 'pay_invoice'} : null,
        ]),
        recipient_form_id: null,
        recipient_form: null,
        document_id: null,
        upload_file: null,
        page_id: null,
        form_placeholders: [],
        all_placeholders: _.getUrlPlaceholders(),
      }
    },
    computed: {
      initialFormUrl() {
        if (this.button_url) {
          let url = this.button_url
          return url.split('?')[0]
        }
      },
      buttonState() {
        if (!this.url) return null
        return _.validateUrl(this.url)
      },
      buttonError() {
        if (this.buttonState !== false) return null
        let error = trans('invalid_url')
        if (this.url.trim().indexOf('http://') !== 0 && this.url.trim().indexOf('https://') !== 0) error += ' ' + trans('url_missing_http')
        return error
      },
      emailError() {
        if (!this.url) return null
        if (!_.validateEmail(this.url)) return trans('invalid_email')
        return null
      },
      phoneError() {
        if (!this.url) return null
        if (!_.validatePhone(this.url)) return trans('invalid_phone')
        return null
      },
      targetOptions() {
        return _.compact([
          {text: trans('anchor_target_self'), value: null}, // self
          {text: trans('anchor_target_blank'), value: '_blank'},
          this.mode ==  'form' ? {text: trans('anchor_target_popup'), value: 'popup'} : null, // popup with iframe only for forms
        ])
      },
      placeholderOptions() {
        let index = 0
        return _.reduce(_.keys(this.all_placeholders), (options, group) => {
          let children = _.map(this.all_placeholders[group], (placeholder) => {
            return {
              id: placeholder.url,
              label: placeholder.label,
            }
          })
          options.push({
            id: index++,
            label: group,
            children: children,
            isDefaultExpanded: true
          })
          return options
        }, [])
      },
      emails() {
        return _.uniq(_.compact(_.union(
          [this.organization.auth_user.email],
          [this.organization.email],
          [this.organization.from_email],
          this.organization.verified_from_emails || []
        )));
      },
      phones() {
        return _.uniq(_.compact([
          this.organization.auth_user.mobile,
          this.organization.phone,
        ]));
      },
    },
    watch: {
      button_text() {
        this.text = this.button_text
      },
      button_url() {
        this.url = this.button_url
        let type = _.linkType(this.url, this.mode, this.organization.id)
        if (type == 'form') this.mode = 'form'
        else if (type == 'document') this.mode = 'document'
        else if (type == 'page') this.mode = 'page'
        else if (type == 'email') this.mode = 'email'
        else if (type == 'tel') this.mode = 'tel'
        else if (type == 'i_calendar') this.mode = 'i_calendar'
        else if (type == 'pay_invoice') this.mode = 'pay_invoice'
        else this.mode = 'url'

        if (this.mode == 'form') {
          this.form_placeholders = this.getPlaceHoldersFromUrl(this.button_url)
        }

      },
      button_color() {
        this.color = this.button_color
      },
      button_target() {
        this.target = this.button_target
      },
      button_protocol() {
        this.protocol = this.button_protocol
      },
      text() {
        this.$emit('button_text', this.text)
      },
      url() {
        this.$emit('button_url', this.url)
      },
      color() {
        this.$emit('button_color', this.color)
      },
      target() {
        this.$emit('button_target', this.target)
      },
      protocol() {
        this.$emit('button_protocol', this.protocol)
      },
      mode() {
        if (this.mode != 'form' &&
          this.target == 'popup')
          this.target = null

        if (this.mode == 'i_calendar') {
          let suffix = this.isPaymentForm ? `/org/${this.organization.id}/calendar/invoice/{invoice_ucid}` : `/org/${this.organization.id}/calendar/recipient/{recipient_id}`
          this.url = `${_.isDev ? 'http://activitymessenger.localhost' : 'https://activitymessenger.com'}${suffix}`
        }
        if (this.mode == 'pay_invoice') {
          this.url = `${window.location.origin}/pay/{invoice_ucid}`
        }
      },
    },
    methods: {
      onUrlChange() {
        if (this.recipient_form_id) this.recipient_form_id = null
        if (this.document_id) this.document_id = null
        if (this.page_id) this.page_id = null
        this.$emit('recipient_form_id', this.recipient_form_id)
      },
      onSelectForm(recipient_form) {
        if (this.document_id) this.document_id = null
        if (this.page_id) this.page_id = null

        let query = this.getQueryFromFormPlaceholders()
        this.url = recipient_form ? recipient_form.page_url + (query ? `?${query}` : ''): null

        this.recipient_form = recipient_form
        this.$emit('recipient_form_id', this.recipient_form_id)
      },
      onDocumentFileChange() {
        if (!this.upload_file) return
        const url = `/organization/${this.organization.id}/media/document`
        this.busy = true
        this.error = null
        let formData = new FormData();
        formData.append("file", this.upload_file);
        axios.post(url, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(response => {
          this.document = response.data
          this.url = this.document.short_url
          setTimeout(() => {
            this.upload_file = null
            this.busy = false
            this.$emit('recipient_form_id', this.recipient_form_id)
          }, 100)
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
      onSelectDocument(doc) {
        if (this.recipient_form_id) this.recipient_form_id = null
        if (this.page_id) this.page_id = null
        this.url = doc ? doc.short_url : null
        this.document = doc
        this.$emit('recipient_form_id', this.recipient_form_id)
      },
      onSelectPage(page) {
        if (this.recipient_form_id) this.recipient_form_id = null
        if (this.document_id) this.document_id = null
        this.url = page ? page.short_url : null
        this.page = page
        this.$emit('recipient_form_id', this.recipient_form_id)
      },
      onPlaceHolderSelect(placeholder) {
        if (!placeholder) return
        setTimeout(() => {
          let query = this.getQueryFromFormPlaceholders()
          this.url = this.recipient_form.page_url + (query ? `?${query}` : '')
        }, 100)
      },
      getQueryFromFormPlaceholders() {
        let params = []
        this.form_placeholders.map((item, index) => {
          let placeholder = this.getPlaceholderByUrl(item)
          params.push(placeholder)
        })

        let query = ''
        params.map(obj => {
          let value = obj.value ?? obj.label
          query += `${obj.url}={${encodeURIComponent(value)}}&`
        })

        return query
      },
      getPlaceholderByUrl(url) {
        for (const property in this.all_placeholders) {
          let placeholder = this.all_placeholders[property].find(o => o.url == url)
          if (placeholder) return placeholder
        }
      },
      getPlaceHoldersFromUrl(url) {
        if (!url) return []
        url = new URL(url)
        let urlSearchParams = new URLSearchParams(url.search)
        let params = []
        urlSearchParams.forEach((value, key) => { 
          params.push(key)
        })
        return params
      }
    },
    mounted() {
      this.form_placeholders = this.getPlaceHoldersFromUrl(this.button_url)
      window.buttonComponent = this
    },
  }
</script>